import React from 'react';
import Header from '@shared/header/header.container';
import ExistingClientComponents from './existing-client.components';
import Title from '../../shared/title/title';
import ExistingClientButton from './existing-client-button/existing-client-button';
import { PORTAL_TYPE } from '../../../types/app.types';
import GoBack from '../../shared/go-back/go-back.container';

export type ButtonsDataType = {
  id: string;
  label: string;
  image: {
    path: string;
    alt: string;
  };
  redirectTo: PORTAL_TYPE;
  highlighted: string;
};

interface ExistingClientContentProps {
  buttonsData: ButtonsDataType[];
  redirectTo: (portal: PORTAL_TYPE) => void;
}
const { Container, ButtonsContainer } = ExistingClientComponents;

const ExistingClientContent: React.FunctionComponent<ExistingClientContentProps> = ({
  buttonsData,
  redirectTo
}) => {
  return (
    <>
      <Header type="support" />
      <GoBack />
      <Container>
        <Title text="intermediaryPages.existingClients.title" />
        <ButtonsContainer>
          {buttonsData.map((item) => (
            <ExistingClientButton
              handleOnClick={redirectTo}
              mobileText={item.label}
              image={item.image}
              redirectPath={item.redirectTo}
              key={item.id}
              highlighted={item.highlighted}
            />
          ))}
        </ButtonsContainer>
      </Container>
    </>
  );
};

export default ExistingClientContent;
